import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledIconWithTitle = styled.div`
  display: flex;
  gap: ${pxToVw(18)};

  .icon {
    .activity-icon-class {
      width: ${pxToVw(45)};
      height: ${pxToVw(45)};
    }
  }
  .title-wrapper {
    .title {
      margin-top: ${pxToVw(5)};
      margin-bottom: 0;
    }
    .sub-title {
      font-size: calc(var(--font-size-p) + 2px);
      line-height: var(--line-height-p);
      color: ${Colors.text};
      margin-top: 0;
    }
  }
`;
